/* eslint-disable class-methods-use-this */

class DefaultAuthStrategy {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-empty-function, no-useless-constructor
  constructor(options) {}
  async requestInterceptor(config) {
    return config;
  }
  async onResponseError(axios, error) {
    throw error;
  }
}

export { DefaultAuthStrategy as default };
//# sourceMappingURL=DefaultAuthStrategy.js.map
